import {
    Container,
    Typography,
    Box,

} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import EventListSection from "../../sections/_dashboard/EventListSection";
import SkillSelectionSection from "../../sections/_dashboard/SkillSelectionSection";
import SkillInputSection from "../../sections/_dashboard/SkillInputSection";

export default function TestSections() {
    const { t } = useTranslation();

    let lang = getLang();

    return (
        <Container maxWidth="lg">
            <Typography variant="h3">Test Simple</Typography>


            <div>
                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
            </div>
            <SkillInputSection />
            <EventListSection />
            <SkillSelectionSection />
        </Container>
    )
}
